import * as React from 'react';
import classnames from 'classnames';

import { TileHeader } from '../Header';

import './style.scss';

interface ITileProps {
  id?: string;
  title?: any;
  renderTitle?: () => JSX.Element;
  renderLink?: () => JSX.Element;
  showError?: boolean;
  hideTitle?: boolean;
  errorMessage?: string;
  className?: string;
  isCollapsible?: boolean;
  initialCollapsedState?: boolean;
  onChangeCollapseState?: (state: boolean) => void;
  isCollapsed?: boolean;
}

interface ITileState {
  isCollapsed?: boolean;
}

class Tile extends React.Component<ITileProps, ITileState> {
  static defaultProps: ITileProps = {
    title: 'Enter title',
    renderTitle: null,
    renderLink: null,
    hideTitle: false,
    isCollapsible: false,
    className: '',
    errorMessage: 'Invalid Tile',
    showError: false,
    initialCollapsedState: false,
  };

  constructor(props: ITileProps) {
    super(props);

    this.state = {
      isCollapsed: this.props.initialCollapsedState,
    };
  }

  componentDidUpdate(prevProps: any) {
    if (this.props.isCollapsed !== undefined && prevProps.isCollapsed !== this.props.isCollapsed) {
      this.setState({
        isCollapsed: this.props.isCollapsed,
      });
    }
  }

  toggleCollapseState = (e) => {
    if (this.props.isCollapsible) {
      if (this.props.onChangeCollapseState) {
        this.props.onChangeCollapseState(!this.state.isCollapsed);
      }
      this.setState((prevState) => ({
        isCollapsed: !prevState.isCollapsed,
      }));
    }
  };

  render() {
    const { isCollapsible, title, showError, hideTitle, id, renderTitle, renderLink } = this.props;
    const { isCollapsed } = this.state;

    return (
      <div
        id={id}
        className={classnames(this.props.className, 'tile', {
          'tile--collapsible': isCollapsible,
          'tile--collapsed': isCollapsed,
          'tile--error': showError,
        })}
      >
        {!hideTitle && (
          <TileHeader 
            onCollapseToggle={this.toggleCollapseState} 
            title={title} 
            renderTitle={renderTitle}
            renderLink={renderLink}
          />
        )}
        <div className={classnames('tile-content')}>{this.props.children}</div>
      </div>
    );
  }
}

export default Tile;
